var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _path2, _path3, _path4, _path5, _path6, _circle, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path7, _path8, _line, _line2, _circle2, _circle3, _circle4, _circle5, _path9, _path10, _circle6, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnySnail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#7BD5F5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 60,
    rx: 30,
    ry: 20,
    fill: "#FFF9E3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 50,
    rx: 25,
    ry: 22,
    fill: "#FFF9E3"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 60,
    rx: 30,
    ry: 18,
    fill: "#FFF9E3"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 80,
    rx: 40,
    ry: 25,
    fill: "#FFF9E3"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 330,
    cy: 70,
    rx: 35,
    ry: 28,
    fill: "#FFF9E3"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 360,
    cy: 85,
    rx: 35,
    ry: 20,
    fill: "#FFF9E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,250 C100,235 300,270 400,240 L400,300 L0,300 Z",
    fill: "#F2D16B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290,160 L320,155",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285,180 L315,175",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280,200 L310,195",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50,230 C110,220 170,220 230,220 C290,220 320,230 320,230 L320,260 C260,255 200,255 140,255 C80,255 50,260 50,260 Z",
    fill: "#F0D6AC",
    stroke: "#DB9B48",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50,230 C40,210 50,190 70,190 C90,190 100,210 90,230",
    fill: "#F0D6AC",
    stroke: "#DB9B48",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 180,
    r: 70,
    fill: "#E67E22",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 180,
    rx: 50,
    ry: 40,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 180,
    rx: 35,
    ry: 28,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 180,
    rx: 20,
    ry: 16,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 180,
    rx: 10,
    ry: 8,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180,110 L180,250",
    stroke: "#A04000",
    strokeWidth: 3,
    strokeDasharray: "8,4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110,180 L250,180",
    stroke: "#A04000",
    strokeWidth: 3,
    strokeDasharray: "8,4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 190,
    x2: 60,
    y2: 155,
    stroke: "#DB9B48",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 190,
    x2: 80,
    y2: 155,
    stroke: "#DB9B48",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 150,
    r: 12,
    fill: "white",
    stroke: "#000",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 150,
    r: 12,
    fill: "white",
    stroke: "#000",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 150,
    r: 6,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 150,
    r: 6,
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50,140 L65,135",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75,135 L90,140",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 210,
    r: 15,
    fill: "#EC7063",
    stroke: "#A04000",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40,180 C35,175 35,165 40,160",
    stroke: "#7BD5F5",
    strokeWidth: 3,
    fill: "#7BD5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M100,175 C105,170 105,160 100,155",
    stroke: "#7BD5F5",
    strokeWidth: 3,
    fill: "#7BD5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnySnail1);
export default __webpack_public_path__ + "static/media/funny-snail1.9b353f31db8f404402655e4a21181d85.svg";
export { ForwardRef as ReactComponent };